export * from './BillingModule'
export const billingPath = '/et/company/:companyId/billingModule'
